<template>
  <v-row no-gutters style="position: relative; z-index: 1">
    <v-col cols="12">
      <v-row no-gutters class="mt-4">
        <v-col
          cols="12"
          lg="3"
          xl="3"
          class="d-flex justify-start align-start mt-3"
        >
          <base-btn type="neutral" size="small" icon @click="handleZoomOut">
            <svg
              class="mt-2"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.1665 3.33335C5.94484 3.33335 3.33317 5.94503 3.33317 9.16669C3.33317 12.3883 5.94484 15 9.1665 15C10.7381 15 12.1646 14.3785 13.2135 13.3678C13.2354 13.3393 13.2595 13.3119 13.2856 13.2858C13.3117 13.2596 13.3391 13.2356 13.3677 13.2137C14.3783 12.1648 14.9998 10.7383 14.9998 9.16669C14.9998 5.94503 12.3882 3.33335 9.1665 3.33335ZM15.0264 13.8481C16.0528 12.565 16.6665 10.9375 16.6665 9.16669C16.6665 5.02455 13.3086 1.66669 9.1665 1.66669C5.02437 1.66669 1.6665 5.02455 1.6665 9.16669C1.6665 13.3088 5.02437 16.6667 9.1665 16.6667C10.9373 16.6667 12.5649 16.053 13.8479 15.0266L16.9106 18.0893C17.236 18.4147 17.7637 18.4147 18.0891 18.0893C18.4145 17.7638 18.4145 17.2362 18.0891 16.9108L15.0264 13.8481ZM5.83317 9.16669C5.83317 8.70645 6.20627 8.33335 6.6665 8.33335H11.6665C12.1267 8.33335 12.4998 8.70645 12.4998 9.16669C12.4998 9.62693 12.1267 10 11.6665 10H6.6665C6.20627 10 5.83317 9.62693 5.83317 9.16669Z"
                fill="#636578"
              />
            </svg>
          </base-btn>

          <base-btn
            type="neutral"
            size="small"
            icon
            @click="handleZoomIn"
            class="ml-4"
          >
            <svg
              class="mt-2"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.1665 3.33335C5.94484 3.33335 3.33317 5.94503 3.33317 9.16669C3.33317 12.3883 5.94484 15 9.1665 15C10.7381 15 12.1646 14.3785 13.2135 13.3678C13.2354 13.3393 13.2595 13.3119 13.2856 13.2858C13.3117 13.2596 13.3391 13.2356 13.3677 13.2137C14.3783 12.1648 14.9998 10.7383 14.9998 9.16669C14.9998 5.94503 12.3882 3.33335 9.1665 3.33335ZM15.0264 13.8481C16.0528 12.565 16.6665 10.9375 16.6665 9.16669C16.6665 5.02455 13.3086 1.66669 9.1665 1.66669C5.02437 1.66669 1.6665 5.02455 1.6665 9.16669C1.6665 13.3088 5.02437 16.6667 9.1665 16.6667C10.9373 16.6667 12.5649 16.053 13.8479 15.0266L16.9106 18.0893C17.236 18.4147 17.7637 18.4147 18.0891 18.0893C18.4145 17.7638 18.4145 17.2362 18.0891 16.9108L15.0264 13.8481ZM9.1665 5.83335C9.62674 5.83335 9.99984 6.20645 9.99984 6.66669V8.33335H11.6665C12.1267 8.33335 12.4998 8.70645 12.4998 9.16669C12.4998 9.62693 12.1267 10 11.6665 10H9.99984V11.6667C9.99984 12.1269 9.62674 12.5 9.1665 12.5C8.70627 12.5 8.33317 12.1269 8.33317 11.6667V10H6.6665C6.20627 10 5.83317 9.62693 5.83317 9.16669C5.83317 8.70645 6.20627 8.33335 6.6665 8.33335H8.33317V6.66669C8.33317 6.20645 8.70627 5.83335 9.1665 5.83335Z"
                fill="#636578"
              />
            </svg>
          </base-btn>

          <base-btn
            type="danger"
            size="small"
            class="ml-4"
            :disabled="selectedItemIndex === -1 || deleteLoading"
            @click="handleDeleteTimelineItem"
            :loading="deleteLoading"
          >
            <v-tooltip v-if="selectedItemIndex === -1" top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-icon size="20"> panda-remove </v-icon>
                </div>
              </template>
              <span>{{
                $t('message.pages.timelineVideo.noInteractionSelected')
              }}</span>
            </v-tooltip>
            <v-icon v-else size="20"> panda-remove </v-icon>
          </base-btn>
        </v-col>
        <v-col
          cols="12"
          lg="8"
          xl="8"
          class="ml-auto pt-3 pt-lg-0"
          style="margin-bottom: -10px"
          v-if="hasItemsAtTheSameTimeRange"
        >
          <BaseAlert
            type="warning"
            :title="$t('message.pages.timelineVideo.timelineText')"
            :description="$t('message.pages.timelineVideo.timelineText2')"
          ></BaseAlert>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" style="margin-top: 20px">
      <div
        class="container__video-timeline"
        :class="{ bordered: isDragging }"
        ref="containerVideoTimeline"
      >
        <div
          class="container__images--wrapper scroll--stylized"
          :style="`height: ${3 * 46 + 38}px`"
          ref="containerWrapper"
          @dragover.prevent="handleDragOver"
          @drop="handleDrop"
          @click="handleMouseClickTick"
          @mousedown="
            handleMouseDownTick($event)
            setLastWheelTime($event)
          "
          @mouseup="handleMouseUpTick"
          @wheel="setLastWheelTime('wheel')"
          @touchmove="setLastWheelTime('touch')"
        >
          <PandaProgressLine
            class="progress-line"
            ref="progressLineTimeline"
            :customHeight="tickHeight"
          />
          <div class="container__time-items" ref="containerTimeItems"></div>
          <div class="container__timeline-items" ref="containerTimelineItems">
            <div
              class="timeline-row"
              v-for="(timelineItem, index) in timelineItems"
              :key="`timelineRow__${index}`"
              :style="`width: ${rowContainersWidth}`"
            >
              <div
                class="timeline-item"
                @mousedown="handleActiveFollowMouse($event, index)"
                @mouseup="handleDeactiveFollowMouse()"
                :class="{
                  selected: timelineItem.selected,
                }"
                :style="{
                  left: getTimelineItemDrawInfo(timelineItem).pos,
                  width: getTimelineItemDrawInfo(timelineItem).width,
                  transform: getTimelineItemDrawInfo(timelineItem).transform,
                }"
                v-if="timelineItem.type"
                :title="timelineItem.type"
                @click="handleOpenConfigPage(timelineItem, index)"
              >
                <div class="text-truncate">
                  <div class="move-start-time"></div>
                  <div class="move-end-time"></div>
                  <span class="mx-2">
                    {{ currentTimelineLabels[timelineItem.type] }}
                    {{
                      timelineItem.hasOwnProperty('isDraft') &&
                      timelineItem.isDraft
                        ? `(${$t('message.pages.timelineVideo.notSaved')})`
                        : ''
                    }}
                    {{
                      timelineItem.hasOwnProperty('hasChanges') &&
                      timelineItem.hasChanges &&
                      !timelineItem.isDraft
                        ? `(${$t('message.pages.timelineVideo.notSaved')})`
                        : ''
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import PandaProgressLine from '@/components/PandaProgressLine.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import _ from 'lodash'
import { mapState, mapMutations } from 'vuex'
import { format } from 'date-fns'
import { isEmpty } from 'lodash'
import { v4 } from 'uuid'
import {
  createButtonCtaItem,
  createQuizCtaItem,
  timeToSeconds as utilTimeToSeconds,
} from '@/utils/ctaGenerator'

export default {
  name: 'VideoTimeline',
  props: {
    timelineMaxWidth: {
      type: String,
      default: '400px',
    },
  },
  data() {
    return {
      pixelsPerSecond: 10,
      minPixelsPerSecond: 0.5,
      maxPixelsPerSecond: 27.5,
      lastMouseWheelEventTime: 0,
      isDragging: false,
      rowContainersWidth: '800px',
      followingMouseItemIndex: false,
      resizeMode: false,
      isMouseDownYet: false,
      selectedItemIndex: -1,
      deleteLoading: false,
      dragOffset: 0,
      rafId: null,
      timelineItemsLabels: this.$t(
        'message.pages.timelineVideo.timelineItemsLabels',
        { returnObjects: true }
      ),
      tickHeight: '176px',
      isMovingTick: false,
      movingTickTimer: false,
      isResizing: false,
      forceUpdate: 0,
      resizeFixedPoint: 0,
      currentVideoTime: 0,
      containerPaddingLeft: 12,
    }
  },
  watch: {
    locale: {
      handler() {
        this.updateText()
        this.$nextTick(() => {
          this.forceUpdate++
          this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])
        })
      },
      immediate: true,
    },
    '$route.name': {
      handler: function (routeName) {
        const allowedRouteNames = [
          'VideoPageButton',
          'VideoPageButtonInteraction',
          'VideoPageForm',
          'VideoPageQuizCta',
          'VideoPageChapters',
          'VideoPageInfoBar',
          'VideoPageMiniTrigger',
        ]
        if (
          this.selectedItemIndex >= 0 &&
          !allowedRouteNames.includes(routeName)
        ) {
          this.timelineItems[this.selectedItemIndex].selected = false
          this.selectedItemIndex = -1
        }
      },
      deep: true,
      immediate: true,
    },
    timelineItems: {
      handler() {
        const rowHeight = 46
        const timeIndicatorHeight = 38
        const minRows = 3

        const activeItems = this.timelineItems.filter(
          (item) => !_.isEmpty(item)
        ).length
        const numRows = Math.max(minRows, activeItems)

        const totalHeight = numRows * rowHeight + timeIndicatorHeight

        this.tickHeight = `${totalHeight}px`

        if (this.$refs.containerWrapper) {
          this.$refs.containerWrapper.style.height = `${totalHeight}px`
        }
      },
      deep: true,
    },
    timelineMaxWidth: {
      handler() {
        this.$nextTick(() => {
          setTimeout(() => {
            this.updateMinZoom()
          }, 50)
        })
      },
      immediate: false,
    },
    video: {
      handler(newVal, oldVal) {
        if (oldVal && newVal && oldVal.id !== newVal.id) {
          this.clearPlayerCtas()
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.UPDATE_VIDEO_TIMELINE_ITEMS([{}, {}, {}])
    document.removeEventListener('mouseup', this.mouseUpListener)
    document.removeEventListener('mousemove', this.mouseMoveListener)
    window.removeEventListener('resize', this.updateMinZoom)
    this.$root.$off('updateTimelineLoading')
    this.$root.$off('dragStartInteraction')
    this.$root.$off('dragEndInteraction')
    this.$root.$off('reloadPlayerCtas')
    this.$root.$off('removeUnsavedLabel')
    this.$root.$off('reRenderTimelineItems')
    this.$root.$off('addInteractionToTimeline')
    this.$root.$off('clearVideoCtas')

    if (this.rafId) {
      cancelAnimationFrame(this.rafId)
    }

    this.clearPlayerCtas()
  },
  mounted() {
    this.$root.$on('changeLanguage', this.updateText)
    document.addEventListener('mouseup', this.mouseUpListener)
    document.addEventListener('mousemove', this.mouseMoveListener)

    this.$nextTick(() => {
      this.clearPlayerCtas()
    })

    this.$root.$on('reloadPlayerCtas', () => {
      this.handleLoadTimelineItemsCtas()
    })
    this.$root.$on('updateTimelineLoading', (val) => {
      this.deleteLoading = val
    })
    this.$root.$on('dragStartInteraction', (item, e) => {
      this.handleDragStart(item, e)
    })
    this.$root.$on('dragEndInteraction', () => {
      this.handleDragLeave()
    })
    this.$root.$on('reRenderTimelineItems', () => {
      this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])
    })
    this.$root.$on('addInteractionToTimeline', (item) => {
      this.handleAddInteractionFromClick(item)
    })
    this.$root.$on('clearVideoCtas', () => {
      this.clearPlayerCtas()
    })
    this.buildTimelineComponents(true)

    window.addEventListener(
      'message',
      (event) => {
        const { data } = event
        if (data.message === 'panda_ready') {
          // Sempre limpar as CTAs primeiro quando o player estiver pronto
          this.clearPlayerCtas()

          // Depois carregar as CTAs do vídeo atual, se houver
          if (!this.timelineItems.every((item) => isEmpty(item))) {
            this.handleLoadTimelineItemsCtas()
          }
        }
        if (data.message === 'panda_timeupdate') {
          if (
            !data.isMutedIndicator &&
            !this.isMovingTick &&
            data.isPreviousProgressLoaded &&
            this.$refs.progressLineTimeline &&
            this.$refs.progressLineTimeline.$el
          ) {
            const currentTime = data.currentTime || data.time
            this.currentVideoTime = currentTime
            const leftPercent = this.getTimelinePositionFromTime(currentTime)
            this.$refs.progressLineTimeline.$el.style.left = `${
              leftPercent > 0 ? leftPercent : 0
            }px`
            if (
              Date.now() - this.lastMouseWheelEventTime > 10000 ||
              this.lastMouseWheelEventTime === 0
            ) {
              const scrollCalc =
                this.getTimelinePositionFromTime(currentTime) - 200
              document.querySelector('.container__images--wrapper').scrollTo({
                left: scrollCalc < 200 ? 0 : scrollCalc,
                behavior: 'smooth',
              })
            }
          }
        }
      },
      false
    )

    if (this.buttonsCta.length) {
      this.buttonsCta.forEach((item) => {
        item = this.handlePreAddItemOnTimeline({
          type: 'button',
          data: item,
          isDraft: false,
        })
        this.handleAddItemOnTimeline(item)
      })
    }
    if (this.quizCta.length) {
      this.quizCta.forEach((item) => {
        item = this.handlePreAddItemOnTimeline({ type: 'quiz', data: item })
        this.handleAddItemOnTimeline(item)
      })
    }
    if (this.formsCta.length) {
      this.formsCta.forEach((item) => {
        item = this.handlePreAddItemOnTimeline({ type: 'form', data: item })
        this.handleAddItemOnTimeline(item)
      })
    }

    this.$root.$on('removeUnsavedLabel', () => {
      this.timelineItems.forEach((item) => {
        if (item.hasOwnProperty('isDraft')) {
          item.isDraft = false
        }
        if (item.hasOwnProperty('hasChanges')) {
          item.hasChanges = false
        }
      })
      this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])
    })

    this.$nextTick(() => {
      setTimeout(() => {
        this.updateMinZoom()
      }, 100)
    })
  },
  components: { PandaProgressLine, BaseAlert },
  methods: {
    ...mapMutations('dashboard', ['UPDATE_VIDEO_TIMELINE_ITEMS']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    setLastWheelTime(event) {
      if (
        (event && (event.which == 2 || event.button == 4)) ||
        event === 'wheel' ||
        event === 'touch'
      ) {
        this.lastMouseWheelEventTime = Date.now()
      }
    },
    updateText() {
      this.timelineItems.forEach((item) => {
        if (item.type) {
          item.text = this.currentTimelineLabels[item.type]
        }
      })
      this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])
    },
    handleLoadTimelineItemsCtas() {
      const ctas = this.generateEditingCta()

      if (this.video.hasOwnProperty('video_source')) {
        this.$root.$emit('setCtas', ctas)
      } else {
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'ctas',
            parameter: {
              ctas,
            },
            preventTimeUpdate: this.isResizing,
          },
          '*'
        )
        this.$root.$emit('setCtas', ctas)
      }
      this.updateSaveArray()
    },

    updateSaveArray() {
      // this.timelineItems.forEach((item) => {
      //   if (item.data && item.data.metadata) {
      //     const ctaIndex = this.$globalSettings.saveArray.findIndex(
      //       (cta) => cta.ctaId === item.data.id
      //     )
      //     if (ctaIndex !== -1) {
      //       const ctaData = this.$globalSettings.saveArray[ctaIndex].ctaData
      //       ctaData.time = item.data.time
      //       ctaData.duration = item.data.duration
      //       ctaData.metadata.startTime = item.data.metadata.startTime
      //       ctaData.metadata.endTime = item.data.metadata.endTime
      //     }
      //   }
      // })
      //console.log('updateSaveArray')
    },
    generateEditingCta() {
      if (!this.timelineItems || !Array.isArray(this.timelineItems)) return []

      let timelineItemsCta = this.timelineItems.filter((item) => !isEmpty(item))
      if (timelineItemsCta.length) {
        timelineItemsCta = timelineItemsCta.map((item) => {
          const ctaData = { ...item.data }

          // For quiz CTAs in preview: if it has time=1 and startTime='00:00', show it at time=0 for preview
          if (
            item.type === 'quiz' &&
            ctaData.time === 1 &&
            ctaData.metadata?.startTime === '00:00'
          ) {
            ctaData.time = 0
          }

          return ctaData
        })
      } else return []
      return timelineItemsCta
    },
    updateProgressLinePosition() {
      if (
        this.$refs.progressLineTimeline &&
        this.$refs.progressLineTimeline.$el
      ) {
        const newLeft = this.getTimelinePositionFromTime(this.currentVideoTime)
        this.$refs.progressLineTimeline.$el.style.left = `${
          newLeft > 0 ? newLeft : 0
        }px`
      }
    },
    handleZoomIn() {
      const containerWidth =
        this.$refs.containerWrapper.getBoundingClientRect().width
      const minWidth = Math.max(containerWidth, 800) // Ensure minimum width is at least container width or 800px

      // Captura o tempo atual antes de fazer zoom
      if (
        this.$refs.progressLineTimeline &&
        this.$refs.progressLineTimeline.$el
      ) {
        const currentLeft = parseFloat(
          this.$refs.progressLineTimeline.$el.style.left || '0'
        )
        this.currentVideoTime = this.getTimeFromTimelinePosition(currentLeft)
      }

      // Calculate new zoom level
      const newPixelsPerSecond = Math.min(
        this.pixelsPerSecond + 2.5,
        this.maxPixelsPerSecond
      )

      // Calculate resulting timeline width
      const newWidth = this.video.length * newPixelsPerSecond

      // Only apply zoom if it would result in width >= minWidth
      if (newWidth >= minWidth) {
        this.pixelsPerSecond = newPixelsPerSecond
        this.buildTimelineComponents()
        this.updateProgressLinePosition()
      }
    },
    handleZoomOut() {
      // Captura o tempo atual antes de fazer zoom
      if (
        this.$refs.progressLineTimeline &&
        this.$refs.progressLineTimeline.$el
      ) {
        const currentLeft = parseFloat(
          this.$refs.progressLineTimeline.$el.style.left || '0'
        )
        this.currentVideoTime = this.getTimeFromTimelinePosition(currentLeft)
      }

      if (this.pixelsPerSecond - 2.5 < this.minPixelsPerSecond) {
        this.pixelsPerSecond = this.minPixelsPerSecond
      } else {
        this.pixelsPerSecond -= 2.5
      }

      // Preserva o tempo atual durante o ajuste automático
      const preservedTime = this.currentVideoTime
      const wasAdjusted = this.updateMinZoom()

      if (wasAdjusted) {
        // Se o zoom foi ajustado automaticamente, restaura o tempo preservado
        this.currentVideoTime = preservedTime
        this.updateProgressLinePosition()
      } else {
        this.buildTimelineComponents()
        this.updateProgressLinePosition()
      }
    },
    mouseUpListener() {
      if (Number.isInteger(this.followingMouseItemIndex)) {
        this.$root.$emit('timelineDrag', false)
        this.followingMouseItemIndex = false
      }
    },
    mouseMoveListener(event) {
      if (
        !this.isMovingTick &&
        !Number.isInteger(this.followingMouseItemIndex)
      ) {
        document.body.classList.remove('no-select')
        return
      }

      if (this.rafId) {
        cancelAnimationFrame(this.rafId)
      }

      this.rafId = requestAnimationFrame(() => {
        this.handleDragTimelineItems(event)
      })
    },
    getEmptyDateWithSec(sec) {
      return new Date(new Date(0, 0, 0, 0, 0, 0, 0).setSeconds(sec))
    },
    handleDuplicateTimelineItem() {
      const selectedItem = this.timelineItems[this.selectedItemIndex]
      const newDuplicatedItem = _.cloneDeep(selectedItem)
      if (!newDuplicatedItem?.isDraft) {
        newDuplicatedItem.data.id = v4()
        newDuplicatedItem.isDraft = true
      }
      this.timelineItems.splice(
        this.selectedItemIndex + 1,
        0,
        newDuplicatedItem
      )
      this.timelineItems[this.selectedItemIndex].selected = false
      this.handleOpenConfigPage(
        this.timelineItems[this.selectedItemIndex + 1],
        this.selectedItemIndex + 1
      )
    },
    async handleDeleteTimelineItem() {
      if (this.selectedItemIndex >= 0) {
        this.deleteLoading = true
        const selectedItem = this.timelineItems[this.selectedItemIndex]

        try {
          if (selectedItem.type) {
            if (this.isEditingItem(selectedItem)) {
              this.deleteCta(selectedItem)
              this.$root.$emit('handleGoToVideoPageRoute', {
                name: 'VideoPage',
              })
            } else {
              this.deleteCta(selectedItem)
            }
          } else {
            this.removeItemFromTimeline()
          }
        } catch (error) {
          console.error('Error deleting timeline item:', error)
          this.handleErrorSnackbar(
            error?.response?.data?.errMsg ||
              error?.response?.data?.message ||
              this.$t('message.errors.unexpectedError')
          )
        } finally {
          this.deleteLoading = false
          this.selectedItemIndex = -1
        }
      }
    },

    isEditingItem(selectedItem) {
      const routeToTypeMap = {
        VideoPageButtonInteraction: 'button',
        VideoPageButton: 'button',
        VideoPageForm: 'form',
        VideoPageQuizCta: 'quiz',
      }

      const currentRouteType = routeToTypeMap[this.$route.name]

      if (currentRouteType === selectedItem.type) {
        const currentId = this.getCurrentEditingId()
        return currentId === selectedItem.data.id
      }

      return false
    },

    getCurrentEditingId() {
      const { params } = this.$route
      return (
        params.btnId ||
        params.formId ||
        params.quizId ||
        params.infoBarId ||
        params.miniTriggerId ||
        null
      )
    },

    removeItemFromTimeline() {
      if (this.timelineItems.length <= 3) {
        this.timelineItems.splice(this.selectedItemIndex, 1, {})
      } else {
        this.timelineItems.splice(this.selectedItemIndex, 1)
      }
      this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])
      this.handleLoadTimelineItemsCtas()
    },

    deleteCta(selectedItem) {
      const hooks = {
        button: 'handleDeleteButton',
        form: 'handleDeleteForm',
        quiz: 'handleDeleteQuizCta',
      }

      const hookName = hooks[selectedItem.type]
      if (hookName) {
        this.$root.$emit(hookName, selectedItem.data)
      }

      this.removeItemFromTimeline()
      const ctas = this.generateEditingCta()
      if (this.video.hasOwnProperty('video_source')) {
        this.$root.$emit('setCtas', ctas)
      } else {
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'ctas',
            parameter: {
              ctas,
            },
          },
          '*'
        )
        this.$root.$emit('setCtas', ctas)
      }
    },

    navigateToMainPage() {
      this.$root.$emit('handleGoToVideoPageRoute', {
        name: 'VideoPage',
      })
    },
    handleDragTimelineItems(event) {
      const timelineContainer = this.$refs.containerVideoTimeline
      const { left: timelineLeftPosOnScreen, right: timelineRightPosOnScreen } =
        timelineContainer.getBoundingClientRect()

      let mouseXaxisPos = event.clientX
      let originalMouseXaxisPos = mouseXaxisPos
      const isDraggingValidItem = Number.isInteger(this.followingMouseItemIndex)
      const canUseMoveMode = isDraggingValidItem && !this.resizeMode
      const canUseResizeMode = this.resizeMode && isDraggingValidItem

      if (this.isMovingTick) {
        document.body.classList.add('no-select')
        mouseXaxisPos =
          mouseXaxisPos -
          timelineLeftPosOnScreen +
          this.$refs.containerWrapper.scrollLeft

        // Aplicar o mesmo offset usado no clique para manter consistência
        const newVideoCurrentTime = this.getTimeFromClickPosition(mouseXaxisPos)
        if (newVideoCurrentTime > this.video.length || newVideoCurrentTime < 0)
          return

        if (
          this.$refs.progressLineTimeline &&
          this.$refs.progressLineTimeline.$el
        ) {
          const progressLinePos =
            this.getClickPositionFromTime(newVideoCurrentTime)
          this.$refs.progressLineTimeline.$el.style.left = `${
            progressLinePos > 0 ? progressLinePos : 0
          }px`
        }
        this.handleScrollTimeline(
          originalMouseXaxisPos,
          timelineLeftPosOnScreen,
          timelineRightPosOnScreen,
          8,
          true
        )
        if (!this.isResizing) {
          const iframe = document.getElementById('panda-player').contentWindow
          iframe.postMessage(
            {
              type: 'currentTime',
              parameter: newVideoCurrentTime,
            },
            '*'
          )
        }
        return
      }

      const selectedItem = this.timelineItems[this.followingMouseItemIndex]
      if (isDraggingValidItem) {
        if (!selectedItem || !selectedItem.data) {
          console.warn(
            'Selected item is invalid or missing data:',
            selectedItem
          )
          return
        }

        if (!selectedItem.data.metadata) {
          console.warn('Selected item is missing metadata:', selectedItem)
          console.warn('selectedItem.data:', selectedItem.data)
          return
        }
      }

      if (canUseMoveMode) {
        mouseXaxisPos =
          mouseXaxisPos -
          timelineLeftPosOnScreen +
          this.$refs.containerWrapper.scrollLeft -
          this.dragOffset

        // Calculate new start time in seconds
        let newStartTimeSeconds = this.getTimeFromClickPosition(mouseXaxisPos)

        // Ensure start time is not negative
        newStartTimeSeconds = Math.max(0, newStartTimeSeconds)

        // Calculate end time
        let newEndTimeSeconds = newStartTimeSeconds + selectedItem.data.duration

        // If end time exceeds video length, adjust start time to fit
        if (newEndTimeSeconds > this.video.length) {
          newStartTimeSeconds = Math.max(
            0,
            this.video.length - selectedItem.data.duration
          )
          newEndTimeSeconds = newStartTimeSeconds + selectedItem.data.duration
        }

        // Only proceed if the new position is valid
        if (
          newStartTimeSeconds >= 0 &&
          newEndTimeSeconds <= this.video.length
        ) {
          const newStartTimeDate = this.getEmptyDateWithSec(newStartTimeSeconds)
          const newEndTimeDate = this.getEmptyDateWithSec(newEndTimeSeconds)

          const startFormat =
            newStartTimeDate.getHours() > 0 ? 'HH:mm:ss' : 'mm:ss'
          const endFormat = newEndTimeDate.getHours() > 0 ? 'HH:mm:ss' : 'mm:ss'

          selectedItem.data.metadata.startTime = format(
            newStartTimeDate,
            startFormat
          )

          // For quiz CTAs that are moved to 00:00, internally store as 1 second
          if (selectedItem.type === 'quiz' && newStartTimeSeconds === 0) {
            selectedItem.data.time = 1
          } else {
            selectedItem.data.time = newStartTimeSeconds
          }

          selectedItem.data.metadata.endTime = format(newEndTimeDate, endFormat)

          this.handleScrollTimeline(
            originalMouseXaxisPos,
            timelineLeftPosOnScreen,
            timelineRightPosOnScreen,
            selectedItem.data.duration * this.pixelsPerSecond,
            false
          )
        }
      } else if (canUseResizeMode) {
        mouseXaxisPos =
          mouseXaxisPos -
          timelineLeftPosOnScreen +
          this.$refs.containerWrapper.scrollLeft

        // duração mínima baseada em pixels para garantir que o elemento nunca fique menor que o min-width
        const minItemPixelWidth = 80 // corresponde ao .timeline-item { min-width: 80px }
        const minDurationDynamic = Math.max(
          1,
          minItemPixelWidth / this.pixelsPerSecond
        )
        const minDuration = minDurationDynamic

        let newStartTimeSeconds
        let newEndTimeSeconds

        if (this.resizeMode === 'start') {
          newEndTimeSeconds = Math.min(this.resizeFixedPoint, this.video.length)
          newStartTimeSeconds = Math.max(
            0,
            Math.min(
              this.getTimeFromClickPosition(mouseXaxisPos),
              newEndTimeSeconds - minDuration
            )
          )
          if (newEndTimeSeconds - newStartTimeSeconds < minDuration) {
            // Bloqueia resize quando atinge o tamanho mínimo
            return
          }
        } else if (this.resizeMode === 'end') {
          newStartTimeSeconds = this.resizeFixedPoint
          newEndTimeSeconds = Math.min(
            this.video.length,
            Math.max(
              newStartTimeSeconds + minDuration,
              this.getTimeFromClickPosition(mouseXaxisPos)
            )
          )
          if (newEndTimeSeconds - newStartTimeSeconds < minDuration) {
            // Bloqueia resize quando atinge o tamanho mínimo
            return
          }
        }

        // Only proceed if the new times are valid
        if (
          newStartTimeSeconds >= 0 &&
          newEndTimeSeconds <= this.video.length &&
          newStartTimeSeconds < newEndTimeSeconds
        ) {
          const duration = newEndTimeSeconds - newStartTimeSeconds
          const newStartTimeDate = this.getEmptyDateWithSec(newStartTimeSeconds)
          const newEndTimeDate = this.getEmptyDateWithSec(newEndTimeSeconds)

          const startFormat =
            newStartTimeDate.getHours() > 0 ? 'HH:mm:ss' : 'mm:ss'
          const endFormat = newEndTimeDate.getHours() > 0 ? 'HH:mm:ss' : 'mm:ss'

          selectedItem.data.metadata.startTime = format(
            newStartTimeDate,
            startFormat
          )

          // For quiz CTAs that are resized to start at 00:00, internally store as 1 second
          if (selectedItem.type === 'quiz' && newStartTimeSeconds === 0) {
            selectedItem.data.time = 1
          } else {
            selectedItem.data.time = newStartTimeSeconds
          }

          selectedItem.data.metadata.endTime = format(newEndTimeDate, endFormat)
          selectedItem.data.duration = duration

          this.handleScrollTimeline(
            originalMouseXaxisPos,
            timelineLeftPosOnScreen,
            timelineRightPosOnScreen,
            selectedItem.data.duration * this.pixelsPerSecond,
            true
          )
        }
      }

      if (canUseMoveMode || canUseResizeMode) {
        this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])
        this.handleLoadTimelineItemsCtas()
      }
    },
    handleScrollTimeline(
      mouseXaxisPos,
      timelineLeftPosOnScreen,
      timelineRightPosOnScreen,
      size,
      resizeMode
    ) {
      let rightValueCalc = !resizeMode ? mouseXaxisPos + size : mouseXaxisPos
      if (rightValueCalc > timelineRightPosOnScreen) {
        this.$refs.containerWrapper.scrollLeft += 120
      }
      if (mouseXaxisPos < timelineLeftPosOnScreen) {
        this.$refs.containerWrapper.scrollLeft -= 120
      }
    },
    handlePixelValuesAsNumbers(value) {
      return Number(value.replace('px', ''))
    },
    handleActiveFollowMouse(event, index) {
      this.isMouseDownYet = true
      document.body.classList.add('no-select')
      event.preventDefault()
      const timelineItem = event.currentTarget
      const itemRect = timelineItem.getBoundingClientRect()
      this.dragOffset = event.clientX - itemRect.left

      setTimeout(() => {
        if (this.isMouseDownYet) {
          const { target } = event
          const itemData = this.timelineItems[index].data
          if (target.classList.contains('move-start-time')) {
            this.resizeMode = 'start'
            this.isResizing = true
            this.resizeFixedPoint = itemData.time + itemData.duration
          } else if (target.classList.contains('move-end-time')) {
            this.resizeMode = 'end'
            this.isResizing = true
            this.resizeFixedPoint = itemData.time
          } else {
            this.resizeMode = false
            this.isResizing = false
          }
          this.$root.$emit('timelineDrag', true)
          this.followingMouseItemIndex = index

          document.addEventListener('mouseup', this.handleMouseUpTick)
          document.addEventListener('mousemove', this.mouseMoveListener)
        }
      }, 200)
    },
    handleDeactiveFollowMouse() {
      this.isMouseDownYet = false
      document.body.classList.remove('no-select')
      this.$root.$emit('timelineDrag', false)
      // --- SNAP AO SOLTAR O DRAG ---
      if (
        Number.isInteger(this.followingMouseItemIndex) &&
        this.followingMouseItemIndex >= 0
      ) {
        const item = this.timelineItems[this.followingMouseItemIndex]
        if (item && item.data && item.data.duration) {
          // Preserva a duração original
          const originalDuration = item.data.duration

          // Snap para o segundo mais próximo (arredonda para o inteiro mais próximo)
          const snappedStart = Math.round(item.data.time)
          const snappedEnd = snappedStart + originalDuration

          // Ajusta apenas o tempo de início, mantendo a duração
          item.data.time = snappedStart
          item.data.duration = originalDuration

          // Atualiza metadata
          const newStartTimeDate = this.getEmptyDateWithSec(snappedStart)
          const newEndTimeDate = this.getEmptyDateWithSec(snappedEnd)
          const startFormat =
            newStartTimeDate.getHours() > 0 ? 'HH:mm:ss' : 'mm:ss'
          const endFormat = newEndTimeDate.getHours() > 0 ? 'HH:mm:ss' : 'mm:ss'
          item.data.metadata.startTime = format(newStartTimeDate, startFormat)
          item.data.metadata.endTime = format(newEndTimeDate, endFormat)
        }
        this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])
        this.handleLoadTimelineItemsCtas()
      }
      this.followingMouseItemIndex = false
      this.resizeMode = false
      this.isResizing = false
      this.dragOffset = 0
      this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])

      document.removeEventListener('mouseup', this.handleMouseUpTick)
      document.removeEventListener('mousemove', this.mouseMoveListener)
    },
    handleDragStart(item, event) {
      this.isDragging = true
      event.dataTransfer.setData('item', JSON.stringify(item))
      event.dataTransfer.effectAllowed = 'move'
      event.target.classList.add('dragged-item')
    },
    handleDragOver(event) {
      if (this.isDragging) {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move'
      }
    },
    handleDragLeave() {
      this.isDragging = false
      if (document.body.style.cursor === 'grabbing') {
        document.body.style.cursor = ''
      }

      this.$root.$emit('reloadPlayerCtas')
    },
    handleOpenConfigPage(item, itemIndex) {
      this.timelineItems.forEach((item) => {
        if (item.selected) {
          item.selected = false
        }
        return item
      })
      item.selected = true
      this.selectedItemIndex = itemIndex
      this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])
      this.moveCursorToInteractionStart(item)
      const routeComponents = {
        button: {
          name: 'VideoPageButtonInteraction',
          params: {
            btnId: item.data.id || itemIndex,
          },
        },
        quiz: {
          name: 'VideoPageQuizCta',
          params: {
            quizId: item.data.id || itemIndex,
          },
        },
        form: {
          name: 'VideoPageForm',
          params: {
            formId: item.data.id || itemIndex,
          },
        },
      }
      const pushConfig = routeComponents[item.type]
      this.$root.$emit('handleGoToVideoPageRoute', pushConfig)
    },
    timeToSeconds: utilTimeToSeconds,

    moveCursorToInteractionStart(item) {
      if (!item || !item.data || item.data.time === undefined) return

      let startTime = item.data.time
      if (
        item.type === 'quiz' &&
        startTime === 1 &&
        item.data.metadata?.startTime === '00:00'
      ) {
        startTime = 0
      }
      const offsetSeconds = 0.5
      const adjustedTime = Math.max(0, startTime - offsetSeconds)

      this.currentVideoTime = adjustedTime
      if (
        this.$refs.progressLineTimeline &&
        this.$refs.progressLineTimeline.$el
      ) {
        const newLeft = this.getTimelinePositionFromTime(adjustedTime)
        this.$refs.progressLineTimeline.$el.style.left = `${
          newLeft > 0 ? newLeft : 0
        }px`
      }
      if (!this.isResizing) {
        const iframe = document.getElementById('panda-player')?.contentWindow
        if (iframe) {
          iframe.postMessage(
            {
              type: 'currentTime',
              parameter: adjustedTime,
            },
            '*'
          )
        }
      }
      this.$nextTick(() => {
        const scrollCalc = this.getTimelinePositionFromTime(adjustedTime) - 200
        const container = document.querySelector('.container__images--wrapper')
        if (container) {
          container.scrollTo({
            left: scrollCalc < 200 ? 0 : scrollCalc,
            behavior: 'smooth',
          })
        }
      })
    },
    getTimelineItemDrawInfo(item) {
      if (
        !item ||
        !item.data ||
        !item.data.metadata ||
        !item.data.metadata.startTime
      ) {
        return {
          pos: '0px',
          width: '150px',
          transform: 'none',
        }
      }
      let startSeconds = item.data.time || 0
      if (
        item.type === 'quiz' &&
        startSeconds === 1 &&
        item.data.metadata.startTime === '00:00'
      ) {
        startSeconds = 0
      }
      const positionCalc = this.getTimelinePositionFromTime(startSeconds)

      let multiplier = 0.1
      if (this.pixelsPerSecond > 30) multiplier = 0.015
      if (this.pixelsPerSecond > 50) multiplier = -0.15
      let positionCalcSubtractor =
        (multiplier + this.pixelsPerSecond / 100) * this.pixelsPerSecond

      return {
        pos: `${positionCalc - positionCalcSubtractor}px`,
        width: `${(item.data.duration + 1 || 10) * this.pixelsPerSecond}px`,
        transform:
          this.followingMouseItemIndex !== false
            ? 'translate3d(0,0,0)'
            : 'none',
      }
    },
    handlePreAddItemOnTimeline(item) {
      if (
        !item.hasOwnProperty('data') ||
        !item.data.hasOwnProperty('metadata')
      ) {
        item.isDraft = true
        const progressBarPosition = this.handlePixelValuesAsNumbers(
          this.$refs.progressLineTimeline.$el.style.left
        )

        // Adjust duration for short videos - use minimum of 10 seconds or 80% of video length
        const maxDuration = Math.max(1, this.video.length * 0.8) // At least 1 second, max 80% of video
        const newDuration = Math.min(10, maxDuration)

        let startTimeSeconds =
          this.getTimeFromTimelinePosition(progressBarPosition)
        let balancer = 0

        // Ensure the interaction fits within the video length
        if (startTimeSeconds + newDuration > this.video.length) {
          balancer = startTimeSeconds + newDuration - this.video.length
        }

        // Ensure start time is not negative
        startTimeSeconds = Math.max(0, startTimeSeconds - balancer)

        // Final check to ensure end time doesn't exceed video length
        const finalEndTime = startTimeSeconds + newDuration
        if (finalEndTime > this.video.length) {
          startTimeSeconds = Math.max(0, this.video.length - newDuration)
        }

        let newStartTime = new Date(
          new Date(0, 0, 0, 0, 0, 0, 0).setSeconds(startTimeSeconds)
        )
        let newEndTime = new Date(
          new Date(0, 0, 0, 0, 0, 0, 0).setSeconds(
            startTimeSeconds + newDuration
          )
        )

        const startFormat = newStartTime.getHours() > 0 ? 'HH:mm:ss' : 'mm:ss'
        const endFormat = newEndTime.getHours() > 0 ? 'HH:mm:ss' : 'mm:ss'
        if (!item.data) {
          item.data = {}
        }
        item.data = {
          ...item.data,
          metadata: {
            ...(item.data.metadata || {}),
            startTime: format(newStartTime, startFormat),
            endTime: format(newEndTime, endFormat),
          },
          duration: newDuration,
          time: this.timeToSeconds(format(newStartTime, startFormat)),
          id: item.data.id || v4(),
        }
        if (item.type === 'button') {
          item.data = createButtonCtaItem(
            item.data,
            this.timeToSeconds(format(newStartTime, startFormat)),
            newDuration
          )
        }
        if (item.type === 'quiz') {
          item.data = createQuizCtaItem(
            item.data,
            this.timeToSeconds(format(newStartTime, startFormat)),
            newDuration
          )
        }

        const timelineItemsLength = this.timelineItems.length
        document.querySelector('.container__images--wrapper').scrollTo({
          left: progressBarPosition - 194,
          top: timelineItemsLength > 3 ? 10000 : 0,
          behavior: 'smooth',
        })
      }
      return item
    },
    handleAddItemOnTimeline(item, replaceIndex = -1) {
      const emptyTimelineItemIndex = this.timelineItems.findIndex((item) =>
        isEmpty(item)
      )

      let chosenIndex = -1
      if (replaceIndex >= 0) {
        this.timelineItems[replaceIndex] = item
        chosenIndex = replaceIndex
      } else if (emptyTimelineItemIndex >= 0) {
        this.timelineItems[emptyTimelineItemIndex] = item
        chosenIndex = emptyTimelineItemIndex
      } else {
        this.timelineItems.push(item)
        chosenIndex = this.timelineItems.length - 1
      }

      this.UPDATE_VIDEO_TIMELINE_ITEMS([...this.timelineItems])

      // Carregar CTAs imediatamente após adicionar o item
      this.$nextTick(() => {
        this.handleLoadTimelineItemsCtas()
      })

      return chosenIndex
    },
    handleDrop(event) {
      if (!this.isDragging) return

      this.isDragging = false
      let item = JSON.parse(event.dataTransfer.getData('item'))

      item = this.handlePreAddItemOnTimeline(item)
      const chosenIndex = this.handleAddItemOnTimeline(item)

      event.preventDefault()
      event.target.classList.remove('dragged-item')
      document.body.style.cursor = ''

      this.handleOpenConfigPage(this.timelineItems[chosenIndex], chosenIndex)
    },
    handleAddInteractionFromClick(item) {
      const processedItem = this.handlePreAddItemOnTimeline(item)
      const chosenIndex = this.handleAddItemOnTimeline(processedItem)
      this.handleOpenConfigPage(this.timelineItems[chosenIndex], chosenIndex)
    },
    checkMoveTickFallback(event) {
      return event.target.matches(
        '.timeline-item, .timeline-item *, .time__stick, .time__stick *, span'
      )
    },
    handleMouseClickTick(event) {
      if (event && (event.which == 2 || event.button == 4)) return
      if (this.checkMoveTickFallback(event)) return

      const timelineContainer = this.$refs.containerVideoTimeline
      const { left: timelineLeftPosOnScreen } =
        timelineContainer.getBoundingClientRect()
      const { clientX } = event

      let mouseXaxisPos =
        clientX -
        timelineLeftPosOnScreen +
        this.$refs.containerWrapper.scrollLeft

      const newVideoCurrentTime = this.getTimeFromClickPosition(mouseXaxisPos)
      if (newVideoCurrentTime > this.video.length || newVideoCurrentTime < 0)
        return

      if (
        this.$refs.progressLineTimeline &&
        this.$refs.progressLineTimeline.$el
      ) {
        const progressLinePos =
          this.getTimelinePositionFromTime(newVideoCurrentTime)
        this.$refs.progressLineTimeline.$el.style.left = `${
          progressLinePos > 0 ? progressLinePos : 0
        }px`
      }
      if (!this.isResizing) {
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'currentTime',
            parameter: newVideoCurrentTime,
          },
          '*'
        )
      }
    },
    handleMouseDownTick(event) {
      if (event && (event.which == 2 || event.button == 4)) return
      if (this.checkMoveTickFallback(event)) return
      this.isMovingTick = true
      this.movingTickTimer = new Date().getTime()

      document.addEventListener('mouseup', this.handleMouseUpTick)
      document.addEventListener('mousemove', this.mouseMoveListener)
    },
    handleMouseUpTick() {
      this.isMovingTick = false
      this.handleDeactiveFollowMouse()
      this.$root.$emit('timelineDrag', false)

      document.removeEventListener('mouseup', this.handleMouseUpTick)
      document.removeEventListener('mousemove', this.mouseMoveListener)
    },
    async buildTimelineComponents(firstBuild = false) {
      const _this = this
      const containers = {
        images:
          _this.$refs.containerWrapper.querySelector('.container__images'),
        timelineItems: _this.$refs.containerWrapper.querySelectorAll(
          '.container__timeline-items .timeline-row'
        ),
        timeItems: _this.$refs.containerWrapper.querySelector(
          '.container__time-items'
        ),
      }

      const setContainersWidth = () => {
        const containerWidth =
          this.$refs.containerWrapper.getBoundingClientRect().width
        const minWidth = Math.max(containerWidth, 800) // Ensure minimum width is at least container width or 800px
        const calculatedWidth = this.video.length * this.pixelsPerSecond

        // Use the larger of calculated width or minimum width
        const width = `${Math.max(calculatedWidth, minWidth)}px`

        containers.timeItems.style.width = width
        this.rowContainersWidth = width
      }

      if (containers.timelineItems && containers.timelineItems.firstChild) {
        while (containers.timelineItems.firstChild) {
          containers.timelineItems.removeChild(
            containers.timelineItems.firstChild
          )
        }
      }
      if (containers.timeItems && containers.timeItems.firstChild) {
        while (containers.timeItems.firstChild) {
          containers.timeItems.removeChild(containers.timeItems.firstChild)
        }
      }

      const loadTimeIndicators = () => {
        let zoomSize = 'normal'
        if (this.pixelsPerSecond < 7.5) zoomSize = 'small'
        if (this.pixelsPerSecond < 1) zoomSize = 'smaller'
        const timeLabelIntervals = {
          normal: 10,
          small: 24,
          smaller: 128,
        }
        let timeLabelInterval = timeLabelIntervals[zoomSize]
        for (let i = 0; i <= this.video.length; i++) {
          if (i % timeLabelInterval === 0) {
            const timeFormatted = this.getSecondsTimeFormatted(i)

            const container = document.createElement('div')
            container.classList.add('time__stick--content')

            const timeValue = document.createElement('span')
            timeValue.innerHTML = `${timeFormatted}`

            const timeValueContainer = document.createElement('div')
            timeValueContainer.classList.add('time__value--container')
            timeValueContainer.style.left = `${i !== 0 ? -43 + 21 : 0}px`
            timeValueContainer.append(timeValue)

            container.append(timeValueContainer)

            const stickElement = document.createElement('div')
            stickElement.classList.add('time__stick')
            stickElement.style.display = 'block'
            stickElement.style.visibility = 'visible'
            container.append(stickElement)

            container.style.left = `${this.getTimelinePositionFromTime(i)}px`
            containers.timeItems.append(container)
          } else {
            if (zoomSize !== 'normal' && i % 4 !== 0) {
              continue
            } else if (zoomSize === 'smaller' && i % 32 !== 0) {
              continue
            } else {
              const container = document.createElement('div')
              container.classList.add('time__stick')
              container.style.display = 'block'
              container.style.visibility = 'visible'
              container.style.left = `${this.getTimelinePositionFromTime(i)}px`
              containers.timeItems.append(container)
            }
          }
        }
      }

      setContainersWidth()
      loadTimeIndicators()

      if (firstBuild) {
        const wasAdjusted = this.updateMinZoom()
        if (wasAdjusted) {
          setContainersWidth()
          loadTimeIndicators()
        }
      }

      if (firstBuild) {
        window.addEventListener('resize', this.updateMinZoom)
      }
    },
    getSecondsTimeFormatted(sec) {
      const decimal = (sec % 1) * 1000
      let timeFormat = sec >= 3600 ? 'HH:mm:ss' : 'mm:ss'
      return format(new Date(0, 0, 0, 0, 0, sec, decimal), timeFormat)
    },
    // Funções centralizadas para cálculos precisos de posicionamento
    getTimelinePositionFromTime(time) {
      // Sistema unificado: posição direta baseada em pixels por segundo
      // Compensação para o padding-left do container
      return this.pixelsPerSecond * time + this.containerPaddingLeft
    },
    getTimeFromTimelinePosition(position) {
      // Conversão inversa unificada
      return (position - this.containerPaddingLeft) / this.pixelsPerSecond
    },
    // Função para calcular posição de click no timeline
    getClickPositionFromTime(time) {
      // Para clicks, usamos a mesma base de coordenadas
      // O offset de click é aplicado apenas na conversão de posição do mouse
      return this.pixelsPerSecond * time + this.containerPaddingLeft
    },
    getTimeFromClickPosition(position) {
      // Para converter posição do mouse em tempo, aplicamos o offset de click
      const clickOffset = -15
      return (
        (position + clickOffset - this.containerPaddingLeft) /
        this.pixelsPerSecond
      )
    },
    handleMouseWheel(event) {
      event.preventDefault()
      this.lastMouseWheelEventTime = Date.now()

      // Captura o tempo atual antes de fazer zoom
      if (
        this.$refs.progressLineTimeline &&
        this.$refs.progressLineTimeline.$el
      ) {
        const currentLeft = parseFloat(
          this.$refs.progressLineTimeline.$el.style.left || '0'
        )
        this.currentVideoTime = this.getTimeFromTimelinePosition(currentLeft)
      }

      const delta = event.deltaY || event.detail || event.wheelDelta

      if (delta > 0) {
        this.pixelsPerSecond = Math.max(
          this.minPixelsPerSecond,
          this.pixelsPerSecond - 0.5
        )
      } else {
        this.pixelsPerSecond = Math.min(
          this.maxPixelsPerSecond,
          this.pixelsPerSecond + 0.5
        )
      }

      // Check if we need to adjust the zoom level
      const containerWidth =
        this.$refs.containerWrapper.getBoundingClientRect().width
      const calculatedWidth = this.video.length * this.pixelsPerSecond

      if (calculatedWidth < containerWidth) {
        this.pixelsPerSecond = containerWidth / this.video.length
      }

      this.buildTimelineComponents()
      this.updateProgressLinePosition()
    },
    handleSnackbar(item) {
      if (!item) {
        item = this.$t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
    handleErrorSnackbar(errorMsg) {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: errorMsg || this.$t('message.errors.unexpectedError'),
        type: 'error',
      })
    },
    updateMinZoom() {
      if (!this.$refs.containerWrapper || !this.video.length) return false

      const containerWidth =
        this.$refs.containerWrapper.getBoundingClientRect().width

      if (containerWidth < 100) {
        setTimeout(() => this.updateMinZoom(), 100)
        return false
      }

      // Calculate minimum pixels per second needed to fill container width
      const minRequiredPixelsPerSecond = containerWidth / this.video.length

      // Set absolute minimum (never go below 0.5)
      this.minPixelsPerSecond = Math.max(0.5, minRequiredPixelsPerSecond)

      // If current zoom would make timeline too small, adjust it
      if (this.pixelsPerSecond * this.video.length < containerWidth) {
        this.pixelsPerSecond = minRequiredPixelsPerSecond
        this.buildTimelineComponents()
        this.updateProgressLinePosition()
        return true
      }

      return false
    },
    // Função utilitária para snap para segundo mais próximo
    snapToSecondFloor(time) {
      return Math.floor(time)
    },
    snapToSecondCeil(time) {
      return Math.ceil(time)
    },
    clearPlayerCtas() {
      // Limpar explicitamente as CTAs do player
      if (this.video.hasOwnProperty('video_source')) {
        this.$root.$emit('setCtas', [])
      } else {
        const iframe = document.getElementById('panda-player')?.contentWindow
        if (iframe) {
          iframe.postMessage(
            {
              type: 'ctas',
              parameter: {
                ctas: [],
              },
            },
            '*'
          )
        }
      }
      this.$root.$emit('setCtas', [])
    },
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      ctas: (state) => state.video.video.config.ctas,
      timelineItems: (state) => state.dashboard.timelineItems,
    }),
    currentTimelineLabels() {
      return this.$t('message.pages.timelineVideo.timelineItemsLabels', {
        returnObjects: true,
      })
    },
    buttonsCta() {
      if (!this.ctas) return []
      return this.ctas.filter((item) => {
        return (
          item.type === 'video' &&
          item.metadata.hasOwnProperty('selectedButtonSize')
        )
      })
    },
    quizCta() {
      if (!this.ctas) return []
      return this.ctas.filter(
        (item) => item.type === 'video' && item.metadata.ctaType === 'quiz'
      )
    },
    formsCta() {
      if (!this.ctas) return []
      return this.ctas.filter(
        (item) => item.type === 'video' && item.metadata.ctaType === 'form'
      )
    },
    hasItemsAtTheSameTimeRange() {
      if (!this.timelineItems || !Array.isArray(this.timelineItems))
        return false
      if (!this.video?.length) return false

      const timeRanges = this.timelineItems
        .filter(
          (item) =>
            item?.type &&
            item.type !== 'bookmarks' &&
            item?.data?.time !== undefined
        )
        .map((item) => {
          return {
            start: item.data.time,
            end:
              item.data.time + (item.data.duration || 0) > this.video.length
                ? this.video.length
                : item.data.time + (item.data.duration || 0),
          }
        })

      if (!timeRanges || timeRanges.length === 0) return false

      for (let i = 0; i < timeRanges.length; i++) {
        for (let j = i + 1; j < timeRanges.length; j++) {
          if (
            timeRanges[i].start < timeRanges[j].end &&
            timeRanges[i].end > timeRanges[j].start
          ) {
            return true
          }
        }
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .base-button--small[data-v-2b55964b] {
  height: 40px;
  padding: 0 0.45rem;
  font-size: 0.875rem;
}

::v-deep .delete-btn {
  background-color: varFigma(neutral-background) !important;
  border-color: varFigma(neutral-background) !important;
  color: varFigma(feedback-danger) !important;

  &:disabled {
    .v-icon {
      color: varFigma(feedback-danger-light) !important;
    }
  }
}
::v-deep .base-button--danger {
  .v-icon {
    color: varFigma(feedback-danger) !important;
  }
  &:disabled {
    .v-icon {
      color: varFigma(feedback-danger-light) !important;
    }
  }
}

svg {
  path {
    fill: var(--v-neutral-40-light-base) !important;
  }
}
</style>

<style lang="scss">
.card__warning--same-time {
  background-color: #fffbdc80 !important;
  border-radius: 16px !important;
}

.card__timeline-options {
  background-color: #e4ecff !important;
  border-radius: 16px !important;
  padding: 8px 16px;
}

.progress-line {
  position: absolute;
  z-index: 2;
}

.container__video-timeline {
  background-color: varFigma(neutral-100-white);
  padding: 12px 0px 0px 12px;
  max-width: 1785px;
  border-radius: 8px 8px 0px 0px;
  border: 1px solid varFigma(neutral-95-lightest);
  transition: all 0.3s ease;
  position: relative;

  &.bordered {
    border: 2px dashed #3f55ee;
    background-color: #f8f9ff;
    transform: scale(1.01);
    animation: borderBreathing 1.5s ease-in-out infinite;

    .container__time-items {
      background-color: #f8f9ff;
    }
  }
}

@keyframes borderBreathing {
  0% {
    border-color: #3f55ee;
    box-shadow: 0 0 0 0 rgba(63, 85, 238, 0.1);
  }
  50% {
    border-color: #697af2;
    box-shadow: 0 0 10px 2px rgba(63, 85, 238, 0.2);
  }
  100% {
    border-color: #3f55ee;
    box-shadow: 0 0 0 0 rgba(63, 85, 238, 0.1);
  }
}

.bg-dark .container__video-timeline.bordered {
  border: 2px dashed #697af2;
  background-color: #061679;
  animation: borderBreathingDark 1.5s ease-in-out infinite;

  .container__time-items {
    background-color: #061679;
  }
}

@keyframes borderBreathingDark {
  0% {
    border-color: #697af2;
    box-shadow: 0 0 0 0 rgba(105, 122, 242, 0.1);
  }
  50% {
    border-color: #8b98f5;
    box-shadow: 0 0 10px 2px rgba(105, 122, 242, 0.2);
  }
  100% {
    border-color: #697af2;
    box-shadow: 0 0 0 0 rgba(105, 122, 242, 0.1);
  }
}

.timeline-row {
  position: relative;
  height: 46px;
  padding: 8px 0px;
  border-bottom: 1px solid varFigma(neutral-80-lighter);
}

.timeline-row:last-child {
  border-bottom: none;
}

.timeline-item {
  position: absolute;
  font-size: 16px;
  height: 32px;
  font-weight: 400;
  min-width: 25px;
  border-radius: 4px;
  background-color: varFigma(neutral-90);
  color: white;
  border: 1px solid varFigma(neutral-60);
  border-left: 4px solid varFigma(neutral-60);
  border-right: 4px solid varFigma(neutral-60);
  display: flex;
  align-items: center;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;

  .text-truncate {
    cursor: move;
    padding: 0 8px;
    height: 100%;
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
    color: varFigma(neutral-60);
    white-space: nowrap;
    text-overflow: ellipsis;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    .move-start-time {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      width: 10px;
      background-color: varFigma(neutral-60);
      height: 100%;
      left: -3px;
      cursor: col-resize;
    }
    .move-end-time {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      width: 10px;
      background-color: varFigma(neutral-60);
      height: 100%;
      right: -3px;
      cursor: col-resize;
    }
  }

  &.selected {
    background-color: varFigma(brand-90);
    border-color: varFigma(brand-60-base);
    border-left-color: varFigma(brand-60-base);
    border-right-color: varFigma(brand-60-base);

    .text-truncate {
      color: varFigma(brand-60-base);
      .move-start-time,
      .move-end-time {
        background-color: varFigma(brand-60-base);
      }
    }
  }
}

.container__time-items {
  position: sticky;
  top: 0;
  height: 33px;
  background-color: varFigma(neutral-100-white);
  z-index: 1;
  height: 33px;
  transition: background-color 0.3s ease;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  div.time__stick {
    width: 1px;
    height: 6px;
    bottom: 6px;
    background: varFigma(neutral-80-lighter) !important;
    position: absolute;
    display: block !important;
    pointer-events: none;
  }

  div.time__stick--content {
    position: absolute;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    bottom: 0px;
    pointer-events: none;

    .time__value--container {
      color: varFigma(neutral-60);
      position: absolute;
      bottom: 16px;
      pointer-events: none;
    }

    span {
      white-space: nowrap;
      font-family: Rubik;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      color: var(--v-gray-900-base);
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      pointer-events: none;
    }

    .time__stick {
      width: 1px;
      height: 12px;
      background: varFigma(neutral-80-lighter) !important;
      display: block !important;
      pointer-events: none;
    }
  }
}

.container__images {
  display: flex;
  width: 100%;
  padding-bottom: 8px;

  &--wrapper {
    min-width: 100%;
    scroll-behavior: smooth;
    position: relative;
    margin: 0;
    overflow-x: scroll;
    overflow-y: hidden;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    &::-webkit-scrollbar {
      height: 6px;
      width: 6px;
      background: transparent;
      position: relative;
      top: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: var(--v-gray-300-base);
      border-radius: 4px;
    }
    &::-webkit-scrollbar-corner {
      background: transparent;
    }
  }
}

.container__progress-line {
  cursor: move;
}
</style>

<style lang="scss" scoped>
::v-deep .base-button--small {
  width: 40px !important;
  height: 40px !important;
  justify-content: center !important;
  display: flex !important;
}

::v-deep .base-button--danger:disabled {
  background-color: transparent !important;
  border: none !important;
  color: varFigma(feedback-danger-light) !important;
}

::v-deep .base-button--danger {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

svg {
  path {
    fill: var(--v-neutral-40-light-base) !important;
  }
}
</style>
